export * from './Heart';
export * from './Lungs';
export * from './Neuro';
export * from './Hemato';
export * from './Stomach';
export * from './MedicalEquipment';
export * from './Family';
export * from './Syringe';
export * from './HighRisk';
export * from './OxygenMask';
export * from './Scalpel';
